const SaleChannel = {
  path: "",
  name: "",
  redirect: "/saleschannel",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/saleschannel",
      redirect: "/saleschannel",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Sales Channel",
      meta: {
        requiresAuth: true,
        activeUrl: "/saleschannel",
        parent: "saleschannel",

        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/salesChannel"),
          meta: {
            requiresAuth: true,
            activeUrl: "/saleschannel",
            parent: "saleschannel",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Sales Channel Detail",
          component: () => import("@/views/pages/salesChannel/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/saleschannel",
            parent: "saleschannel",

            lv: 2,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default SaleChannel;
